import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { plain_fetch } from "../Common/functions";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";

export default function DocSign({ id }) {
    const [state, setState] = useState(undefined);
    useEffect(() => {
        plain_fetch("/api/27b96f9d5a414e0e89e5971f1285d420/" + id, setState);
    }, []);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Paper style="padding: 10px; ">
                    <Button
                        variant="contained"
                        onClick={() => {
                            window.location.href = "/dashboard/";
                        }}
                    >
                        Retourner au tableau de bord
                    </Button>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <div>
                    {state && state.url && (
                        <iframe
                            width="100%"
                            height="800px"
                            src={state.url}
                        ></iframe>
                        // <iframe
                        //     width="1000px;"
                        //     height="800px;"
                        //     src={`https://staging-app.yousign.com/procedure/sign?members=${state.url}&signatureUi=/signature_uis/76076faf-8254-4ad0-8a35-2d2bc71c551e`}
                        // ></iframe>
                    )}
                </div>
            </Grid>
        </Grid>
    );
}
